module.exports = __webpack_public_path__ + "img/xia1.6562a445.png";